
import Vue from 'vue'
import businessHours from '~/mixins/businessHours'

export default Vue.extend({
  name: 'BusinessHours',
  mixins: [businessHours],
  props: {
    hours: {
      type: String,
      required: true,
      default: ''
    },
    useMerge: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
